import bootstrap from "./components/Technologies/images/bootstrap.png";
import express from "./components/Technologies/images/express.png";
import git from "./components/Technologies/images/git.png";
import jira from "./components/Technologies/images/jira.png";
import mongodb from "./components/Technologies/images/mongodb.png";
import nodejs from "./components/Technologies/images/nodejs.png";
import react from "./components/Technologies/images/reactjs.png";
import responsive from "./components/Technologies/images/responsive.png";
import sass from "./components/Technologies/images/sass.png";
import solidity from "./components/Technologies/images/solidity.png";
import typescript from "./components/Technologies/images/typescript.png";
import vue from "./components/Technologies/images/vuejs.png";

import bgCemex from "./components/Projects/images/bg-cemex.png";
import bgRoca from "./components/Projects/images/bg-roca.png";
import bgBHC from "./components/Projects/images/bg-bhc.png";
import bgTorielli from "./components/Projects/images/bg-torielli.png";
import bgRapiclub from "./components/Projects/images/bg-rapiclub.png";
import bgEnergySimply from "./components/Projects/images/bg-energysimply.png";
import bgPlastic from "./components/Projects/images/bg-plastic.png";
import bgRugbyDat from "./components/Projects/images/bg-rugby-dat.png";
import bgFarmRich from "./components/Projects/images/bg-farm-rich.png";
import bgSeaPak from "./components/Projects/images/bg-sea-pak.png";
import bgSucan from "./components/Projects/images/bg-sucan.png";

import bgValts from "./components/Projects/images/bg-valts.png";

export const API = {
  url: "https://crombie-docs-api-h22-heroku-22.herokuapp.com/"
};
export const estebanCaccin = {
  alias: "Steve",
  name: "Esteban",
  lastname: "Caccin",
  description: "Front-end Developer"
};

export const technologies = [
  {
    image: bootstrap,
    name: "Boostrap"
  },
  {
    image: express,
    name: "Express"
  },
  {
    image: git,
    name: "Git"
  },
  {
    image: jira,
    name: "Jira Software"
  },
  {
    image: mongodb,
    name: "MongoDB"
  },
  {
    image: nodejs,
    name: "Node JS"
  },
  {
    image: react,
    name: "React JS"
  },
  {
    image: responsive,
    name: "Responsive Design"
  },
  {
    image: sass,
    name: "Sass"
  },
  {
    image: solidity,
    name: "Solidity"
  },
  {
    image: typescript,
    name: "Typescript"
  },
  {
    image: vue,
    name: "Vue JS"
  }
];

export const projects = [
  {
    image: bgCemex,
    projectName: "Cemex Landing Page",
    shortDescription: "Cemex Landing Page"
  },
  {
    image: bgRoca,
    projectName: "Roca",
    shortDescription: "Roca"
  },
  {
    image: bgBHC,
    projectName: "Boar's Head",
    shortDescription: "Boar's Head"
  },
  {
    image: bgTorielli,
    projectName: "Torielli Piscinas",
    shortDescription: "Torielli Piscinas"
  },
  {
    image: bgRapiclub,
    projectName: "Rapiclub",
    shortDescription: "Rapiclub"
  },
  {
    image: bgEnergySimply,
    projectName: "Energy Simply",
    shortDescription: "Energy Simply"
  },
  {
    image: bgPlastic,
    projectName: "Plastic Ingenuity",
    shortDescription: "Plastic Ingenuity"
  },
  {
    image: bgRugbyDat,
    projectName: "Rugby Dat",
    shortDescription: "Rugby Dat"
  },
  {
    image: bgFarmRich,
    projectName: "FarmRich",
    shortDescription: "FarmRich"
  },

  {
    image: bgSeaPak,
    projectName: "SeaPak",
    shortDescription: "SeaPak"
  },
  {
    image: bgSucan,
    projectName: "Sucan",
    shortDescription: "Sucan"
  },
  {
    image: bgValts,
    projectName: "Valts",
    shortDescription: "Valts"
  }
];
